import { createLeanGesture } from './leanFactory.js';
export default createLeanGesture('left');
